import type { LLMsViewType, StatesConfig } from '@intone/shared/types';
import { SINGLE_STATE_CONFIG, MULTI_STATE_CONFIG } from '../config/constants';

// Get default config based on view type
export function getDefaultStatesConfig(viewType: LLMsViewType): StatesConfig {
  if (viewType === 'single_prompt') {
    return SINGLE_STATE_CONFIG
  }
  return MULTI_STATE_CONFIG
}

// Ensures states_config is always valid
export function getValidStatesConfig(
  config: StatesConfig | null,
  viewType: LLMsViewType = 'double_state'
): StatesConfig {
  if (!config || Object.keys(config).length === 0) {
    return getDefaultStatesConfig(viewType)
  }

  // Validate each state has required fields
  const validConfig: StatesConfig = {}
  for (const [stateName, stateConfig] of Object.entries(config)) {
    validConfig[stateName] = {
      prompt: stateConfig?.prompt ?? '',
      tools: stateConfig?.tools ?? [],
      is_initial: stateConfig?.is_initial,
      transition: stateConfig?.transition,
    }
  }
  return validConfig
}